module.exports = __webpack_public_path__ + "img/8.02117c94.png";